export const WELLS_LIST_LOAD_LIMIT = 100;
